import type { Styles } from '@adornis/ass/style.js';
import { BreakPoint, mapping } from '@adornis/base/client/frontend-helpers/index.js';
import { fontReset } from '@adornis/fonts/font-resets.js';
import { XH1, XH2, XH3, XH4, XText } from '@adornis/fonts/fonts.js';
import { customElement } from 'lit/decorators.js';

import '@adornis/fonts/fontSrc/montserrat.js';
import 'https://fonts.googleapis.com/css2?family=ABeeZee&display=swap';

// h1-h3 representing display1-3 from the design
/**
 * @customElement cr-h1
 */
@customElement('cr-h1')
export class ChromiumH1 extends XH1 {
  override styles(): Styles[] {
    return super.styles().concat([
      {
        ...fontReset('Montserrat', 2, 600, 1.2),
        [`@media only screen and (max-width: ${mapping[BreakPoint.tablet]}px)`]: fontReset('Montserrat', 1.8, 600, 1.2),
        [`@media only screen and (max-width: ${mapping[BreakPoint.bigPhone]}px)`]: fontReset(
          'Montserrat',
          1.7,
          600,
          1.2,
        ),
      },
    ]);
  }
}

/**
 * @customElement cr-h2
 */
@customElement('cr-h2')
export class ChromiumH2 extends XH2 {
  override styles(): Styles[] {
    return super.styles().concat([
      {
        ...fontReset('Montserrat', 1.8, 600, 1.2),
        [`@media only screen and (max-width: ${mapping[BreakPoint.tablet]}px)`]: fontReset('Montserrat', 1.7, 600, 1.2),
        [`@media only screen and (max-width: ${mapping[BreakPoint.bigPhone]}px)`]: fontReset(
          'Montserrat',
          1.5,
          600,
          1.4,
        ),
      },
    ]);
  }
}

/**
 * @customElement cr-h3
 */
@customElement('cr-h3')
export class ChromiumH3 extends XH3 {
  override styles(): Styles[] {
    return super.styles().concat([
      {
        ...fontReset('Montserrat', 1.4, 600, 1.2),
        [`@media only screen and (max-width: ${mapping[BreakPoint.tablet]}px)`]: fontReset('Montserrat', 1.3, 600, 1.2),
        [`@media only screen and (max-width: ${mapping[BreakPoint.bigPhone]}px)`]: fontReset(
          'Montserrat',
          1.2,
          600,
          1.2,
        ),
      },
    ]);
  }
}

/**
 * @customElement cr-h4
 */
@customElement('cr-h4')
export class ChromiumH4 extends XH4 {
  override styles(): Styles[] {
    return super.styles().concat(
      [
        {
          ...fontReset('Montserrat', 1.0, 500, 1.2),
          [`@media only screen and (max-width: ${mapping[BreakPoint.tablet]}px)`]: fontReset(
            'Montserrat',
            0.9,
            500,
            1.2,
          ),
        },
      ],
      { '&[bold]': fontReset('Montserrat', 1.0, 600, 1.2) },
    );
  }
}

/**
 * @customElement cr-text
 */
@customElement('cr-text')
export class ChromiumText extends XText {
  override styles(): Styles[] {
    return super.styles().concat(
      [
        {
          ...fontReset('Montserrat', 0.8, 400, 1.2),
          [`@media only screen and (max-width: ${mapping[BreakPoint.tablet]}px)`]: fontReset(
            'Montserrat',
            0.7,
            400,
            1.2,
          ),
        },
      ],

      { '&[small]': fontReset('Montserrat', 0.7, 400, 1.2) },
    );
  }
}

/**
 * @customElement cr-levumi-text
 * Custom font for the levumi exercises
 */
@customElement('cr-levumi-text')
export class ChromiumLevumiText extends XText {
  override styles(): Styles[] {
    return super.styles().concat([fontReset('ABeeZee', 28 / this.baseFontSize, 400, 1.5)]);
  }
}
